import React from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import SortableItem from './SortableItem';

const SortableList = ({
    canModify,
    companiesCatalogs,
    //id,
    prepareDelete,
    prepareUpdate,
    type,
}) => {
    return (
        <Box>
            {companiesCatalogs.map((companyCatalog, index) => (
                <SortableItem
                    canModify={canModify}
                    companyCatalog={companyCatalog}
                    id={`item-${companyCatalog.id}`}
                    index={index}
                    key={`item-${companyCatalog.id}`}
                    prepareDelete={prepareDelete}
                    prepareUpdate={prepareUpdate}
                    type={type}
                />
            ))}
        </Box>
    );
};

SortableList.propTypes = {
    canModify: PropTypes.bool,
    companiesCatalogs: PropTypes.array,
    //id: PropTypes.string,
    prepareDelete: PropTypes.func,
    prepareUpdate: PropTypes.func,
    type: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
};

export default SortableList;
